<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Setup"
        [title]="title()"
        subtitle="Create or update the company trailer type master data used by trailer assets.">
        <div actions>
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="cancel()"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="isSaving" (onClick)="save()"></p-button>
        </div>
    </app-page-hero>

    <form [formGroup]="form" class="form-grid">
        <div>
            <app-page-form-section icon="pi pi-tags" title="Trailer Type" subtitle="Code and name must be unique inside the company.">
                <div class="field-grid">
                    <div class="field">
                        <label for="code">Code</label>
                        <input id="code" pInputText formControlName="code" placeholder="FLATBED" />
                    </div>
                    <div class="field">
                        <label for="name">Name</label>
                        <input id="name" pInputText formControlName="name" placeholder="Flatbed Trailer" />
                    </div>
                    <div class="field">
                        <label for="active">Active</label>
                        <p-select inputId="active" [options]="activeOptions" formControlName="active" optionLabel="label" optionValue="value" styleClass="w-full"></p-select>
                    </div>
                    <div class="field">
                        <label for="sortOrder">Sort Order</label>
                        <p-inputNumber inputId="sortOrder" formControlName="sortOrder" [min]="0" styleClass="w-full"></p-inputNumber>
                    </div>
                    <div class="field" style="grid-column: 1 / -1;">
                        <label for="description">Description</label>
                        <textarea id="description" pTextarea formControlName="description" rows="4" placeholder="Operational notes or usage context"></textarea>
                    </div>
                </div>
            </app-page-form-section>
        </div>

        <aside class="summary-panel">
            <h2>Summary</h2>
            <div class="summary-row">
                <span>Code</span>
                <strong>{{ form.value.code || '-' }}</strong>
            </div>
            <div class="summary-row">
                <span>Name</span>
                <strong>{{ form.value.name || '-' }}</strong>
            </div>
            <div class="summary-row">
                <span>Status</span>
                <strong>{{ form.value.active === false ? 'Inactive' : 'Active' }}</strong>
            </div>
        </aside>
    </form>
</app-page-shell>
